var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfSidebar',{staticClass:"mobile-menu-sidebar sf-sidebar--left",attrs:{"visible":"","overlay":false},on:{"close":_vm.handleMobileNavClose}},[_c('MagHeaderNavigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }